import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog';
import { Button } from './button';
import { Checkbox } from './checkbox';
import { ScrollArea } from './scroll-area';
import { useLanguage } from '../../contexts/LanguageContext';

const TerminosCondicionesModal = ({ open, onOpenChange, onAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const { language } = useLanguage();

  const handleAccept = () => {
    if (accepted) {
      onAccept();
      onOpenChange(false);
    }
  };

  const content = {
    es: {
      title: 'Términos y Condiciones de Suscripción',
      lastUpdate: 'Última actualización: Enero 2026',
      intro: <>Al marcar "Acepto términos y condiciones", el usuario mayor de 18 años contrata los servicios de Biblioteca Técnica Aeronáutica de C&M Servicios Aeronáuticos (organización, catalogación y mantenimiento al día de documentación técnica - <em className="text-teal-700">Anexo Alfa</em>). Este constituye un acuerdo digital legalmente vinculante.</>,
      plans: 'PLANES DE SUSCRIPCIÓN',
      premium: {
        title: '✈️ PREMIUM - USD $400/mes',
        promo: null,
        items: [
          'Modalidad: Débito automático MercadoPago / Transferencia',
          'Acceso ilimitado + impresión',
          'Usuarios: Ilimitados',
          'Soporte: Prioritario 24/7'
        ]
      },
      standard: {
        title: '✈️ STANDARD - USD $120/mes',
        promo: 'Promo: $100 débito auto',
        items: [
          'Modalidad: Débito automático MercadoPago / Transferencia',
          'Modelos según capacidad operacional + impresión',
          'Ampliación de capacidades disponible',
          'Usuarios: 2 (dos)',
          'Soporte: Estándar'
        ]
      },
      standardPro: {
        title: '✈️ STANDARD PRO - USD $220/mes',
        promo: 'Promo: $200 débito auto',
        items: [
          'Modalidad: Débito automático MercadoPago / Transferencia',
          'Modelos según capacidad operacional + impresión',
          'Ampliación de capacidades disponible',
          'Usuarios: 5 (cinco)',
          'Soporte: Estándar'
        ]
      },
      itinerante: {
        title: '✈️ ITINERANTE - Personalizado',
        promo: null,
        items: [
          'Para talleres sin certificación específica',
          'Plan adaptado a necesidades particulares',
          'Solicitar cotización personalizada',
          'Soporte: Estándar'
        ]
      },
      statusReport: {
        title: '✈️ STATUS REPORT - GRATIS',
        items: [
          'Reporte de estado + Notificaciones',
          'Adquisición de documentos individuales',
          'Usuarios: 1 (uno)',
          'Soporte: Básico'
        ]
      },
      payment: 'FORMAS DE PAGO',
      paymentMp: 'MercadoPago: Débito automático (requerido para todas las promos)',
      paymentBank: 'Transferencia Bancaria - Banco Galicia:',
      paymentUsd: 'Dólares:',
      paymentArs: 'Pesos:',
      paymentNote: '(cotización BNA del día de acreditación)',
      obligations: 'OBLIGACIONES DEL SUSCRIPTOR',
      obligationItems: [
        'Pago mensual según plan elegido',
        'Acceso web único por taller',
        'Uso exclusivo para mantenimiento aeronáutico',
        <><strong>Confidencialidad absoluta:</strong> Prohibido divulgar o reproducir documentos (Ley 11.723). El incumplimiento implica pérdida de pagos realizados y posibles acciones legales.</>
      ],
      duration: 'DURACIÓN Y CANCELACIÓN',
      durationItems: [
        'Vigencia indefinida hasta cancelación expresa',
        'Cancelación: En cualquier momento vía web o MercadoPago',
        'Suspensión por impago: 2 meses consecutivos o 3 alternos',
        'Terminación por incumplimiento grave: 10 días de notificación previa'
      ],
      privacy: 'PROTECCIÓN DE DATOS',
      privacyText: 'Sus datos personales serán tratados conforme a la Ley 25.326 de Protección de Datos Personales de Argentina.',
      responsibilities: 'RESPONSABILIDADES',
      responsibilityItems: [
        'Soporte: 24/7 vía web | Telefónico L-V 9-19hs',
        'C&M Servicios Aeronáuticos no se responsabiliza por sanciones de autoridades aeronáuticas cuando la documentación provista sea correcta y esté actualizada.'
      ],
      jurisdiction: 'JURISDICCIÓN',
      jurisdictionText: <>Para cualquier controversia se establece la jurisdicción de los Tribunales Ordinarios de la Ciudad de Córdoba, Argentina.<br /><strong>Domicilio legal:</strong> Sucre 2948, Alta Córdoba, Córdoba.</>,
      modifications: 'MODIFICACIONES',
      modificationsText: 'C&M Servicios Aeronáuticos se reserva el derecho de modificar estos términos con 30 días de anticipación, notificando a los usuarios por email.',
      contact: 'CONTACTO',
      acceptLabel: 'He leído y acepto los Términos y Condiciones',
      cancelBtn: 'Cancelar',
      acceptBtn: 'Aceptar y Continuar'
    },
    pt: {
      title: 'Termos e Condições de Assinatura',
      lastUpdate: 'Última atualização: Janeiro 2026',
      intro: <>Ao marcar "Aceito os termos e condições", o usuário maior de 18 anos contrata os serviços da Biblioteca Técnica Aeronáutica da C&M Serviços Aeronáuticos (organização, catalogação e manutenção atualizada de documentação técnica - <em className="text-teal-700">Anexo Alfa</em>). Este constitui um acordo digital legalmente vinculante.</>,
      plans: 'PLANOS DE ASSINATURA',
      premium: {
        title: '✈️ PREMIUM - USD $400/mês',
        promo: null,
        items: [
          'Modalidade: Débito automático MercadoPago / Transferência',
          'Acesso ilimitado + impressão',
          'Usuários: Ilimitados',
          'Suporte: Prioritário 24/7'
        ]
      },
      standard: {
        title: '✈️ STANDARD - USD $120/mês',
        promo: 'Promo: $100 débito auto',
        items: [
          'Modalidade: Débito automático MercadoPago / Transferência',
          'Modelos conforme capacidade operacional + impressão',
          'Ampliação de capacidades disponível',
          'Usuários: 2 (dois)',
          'Suporte: Padrão'
        ]
      },
      standardPro: {
        title: '✈️ STANDARD PRO - USD $220/mês',
        promo: 'Promo: $200 débito auto',
        items: [
          'Modalidade: Débito automático MercadoPago / Transferência',
          'Modelos conforme capacidade operacional + impressão',
          'Ampliação de capacidades disponível',
          'Usuários: 5 (cinco)',
          'Suporte: Padrão'
        ]
      },
      itinerante: {
        title: '✈️ ITINERANTE - Personalizado',
        promo: null,
        items: [
          'Para oficinas sem certificação específica',
          'Plano adaptado às necessidades particulares',
          'Solicitar cotação personalizada',
          'Suporte: Padrão'
        ]
      },
      statusReport: {
        title: '✈️ STATUS REPORT - GRÁTIS',
        items: [
          'Relatório de status + Notificações',
          'Aquisição de documentos individuais',
          'Usuários: 1 (um)',
          'Suporte: Básico'
        ]
      },
      payment: 'FORMAS DE PAGAMENTO',
      paymentMp: 'MercadoPago: Débito automático (necessário para todas as promos)',
      paymentBank: 'Transferência Bancária - Banco Galicia:',
      paymentUsd: 'Dólares:',
      paymentArs: 'Pesos:',
      paymentNote: '(cotação BNA do dia do crédito)',
      obligations: 'OBRIGAÇÕES DO ASSINANTE',
      obligationItems: [
        'Pagamento mensal conforme plano escolhido',
        'Acesso web único por oficina',
        'Uso exclusivo para manutenção aeronáutica',
        <><strong>Confidencialidade absoluta:</strong> Proibido divulgar ou reproduzir documentos (Lei 11.723 Argentina). O descumprimento implica perda dos pagamentos realizados e possíveis ações legais.</>
      ],
      duration: 'DURAÇÃO E CANCELAMENTO',
      durationItems: [
        'Vigência indefinida até cancelamento expresso',
        'Cancelamento: A qualquer momento via web ou MercadoPago',
        'Suspensão por falta de pagamento: 2 meses consecutivos ou 3 alternados',
        'Rescisão por descumprimento grave: 10 dias de notificação prévia'
      ],
      privacy: 'PROTEÇÃO DE DADOS',
      privacyText: 'Seus dados pessoais serão tratados conforme a Lei 25.326 de Proteção de Dados Pessoais da Argentina e a LGPD do Brasil.',
      responsibilities: 'RESPONSABILIDADES',
      responsibilityItems: [
        'Suporte: 24/7 via web | Telefônico Seg-Sex 9-19hs',
        'C&M Serviços Aeronáuticos não se responsabiliza por sanções de autoridades aeronáuticas quando a documentação fornecida esteja correta e atualizada.'
      ],
      jurisdiction: 'JURISDIÇÃO',
      jurisdictionText: <>Para qualquer controvérsia estabelece-se a jurisdição dos Tribunais Ordinários da Cidade de Córdoba, Argentina.<br /><strong>Domicílio legal:</strong> Sucre 2948, Alta Córdoba, Córdoba.</>,
      modifications: 'MODIFICAÇÕES',
      modificationsText: 'C&M Serviços Aeronáuticos reserva-se o direito de modificar estes termos com 30 dias de antecedência, notificando os usuários por email.',
      contact: 'CONTATO',
      acceptLabel: 'Li e aceito os Termos e Condições',
      cancelBtn: 'Cancelar',
      acceptBtn: 'Aceitar e Continuar'
    }
  };

  const c = content[language] || content.es;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-slate-800">
            {c.title}
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            {c.lastUpdate}
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="h-[50vh] pr-4">
          <div className="space-y-6 text-sm text-slate-700">
            {/* Introducción */}
            <p>{c.intro}</p>

            {/* Planes de Suscripción */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.plans}</h3>
              
              <div className="space-y-4">
                {/* Premium */}
                <div className="bg-gradient-to-r from-amber-50 to-orange-50 p-4 rounded-lg border border-amber-200">
                  <h4 className="font-bold text-amber-800 flex items-center gap-2">
                    {c.premium.title}
                  </h4>
                  <ul className="mt-2 space-y-1 text-slate-600">
                    {c.premium.items.map((item, i) => <li key={i}>• {item}</li>)}
                  </ul>
                </div>

                {/* Standard */}
                <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-4 rounded-lg border border-teal-200">
                  <h4 className="font-bold text-teal-800 flex items-center gap-2">
                    {c.standard.title}
                    {c.standard.promo && (
                      <span className="text-xs bg-teal-600 text-white px-2 py-0.5 rounded-full">{c.standard.promo}</span>
                    )}
                  </h4>
                  <ul className="mt-2 space-y-1 text-slate-600">
                    {c.standard.items.map((item, i) => <li key={i}>• {item}</li>)}
                  </ul>
                </div>

                {/* Standard Pro */}
                <div className="bg-gradient-to-r from-sky-50 to-blue-50 p-4 rounded-lg border border-sky-200">
                  <h4 className="font-bold text-sky-800 flex items-center gap-2">
                    {c.standardPro.title}
                    {c.standardPro.promo && (
                      <span className="text-xs bg-sky-600 text-white px-2 py-0.5 rounded-full">{c.standardPro.promo}</span>
                    )}
                  </h4>
                  <ul className="mt-2 space-y-1 text-slate-600">
                    {c.standardPro.items.map((item, i) => <li key={i}>• {item}</li>)}
                  </ul>
                </div>

                {/* Itinerante */}
                <div className="bg-gradient-to-r from-purple-50 to-violet-50 p-4 rounded-lg border border-purple-200">
                  <h4 className="font-bold text-purple-800 flex items-center gap-2">
                    {c.itinerante.title}
                  </h4>
                  <ul className="mt-2 space-y-1 text-slate-600">
                    {c.itinerante.items.map((item, i) => <li key={i}>• {item}</li>)}
                  </ul>
                </div>

                {/* Status Report */}
                <div className="bg-gradient-to-r from-slate-50 to-gray-50 p-4 rounded-lg border border-slate-200">
                  <h4 className="font-bold text-slate-800 flex items-center gap-2">
                    {c.statusReport.title}
                  </h4>
                  <ul className="mt-2 space-y-1 text-slate-600">
                    {c.statusReport.items.map((item, i) => <li key={i}>• {item}</li>)}
                  </ul>
                </div>
              </div>
            </div>

            {/* Formas de Pago */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.payment}</h3>
              <p className="mb-2"><strong>MercadoPago:</strong> {c.paymentMp.split(':')[1]}</p>
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                <p className="font-semibold text-blue-800 mb-2">{c.paymentBank}</p>
                <ul className="space-y-2 text-slate-600">
                  <li>
                    <strong>{c.paymentUsd}</strong><br />
                    CBU: 0070076431004029551598<br />
                    Alias: biblio.tecnica.aer
                  </li>
                  <li>
                    <strong>{c.paymentArs}</strong><br />
                    CBU: 0070076430004127217906<br />
                    Alias: biblio.tecnica.peso<br />
                    <span className="text-xs text-slate-500">{c.paymentNote}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Obligaciones */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.obligations}</h3>
              <ul className="space-y-2">
                {c.obligationItems.map((item, i) => <li key={i}>• {item}</li>)}
              </ul>
            </div>

            {/* Duración y Cancelación */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.duration}</h3>
              <ul className="space-y-2">
                {c.durationItems.map((item, i) => <li key={i}>• {item}</li>)}
              </ul>
            </div>

            {/* Protección de Datos */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.privacy}</h3>
              <p>{c.privacyText}</p>
            </div>

            {/* Responsabilidades */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.responsibilities}</h3>
              <ul className="space-y-2">
                {c.responsibilityItems.map((item, i) => <li key={i}>• {item}</li>)}
              </ul>
            </div>

            {/* Jurisdicción */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.jurisdiction}</h3>
              <p>{c.jurisdictionText}</p>
            </div>

            {/* Modificaciones */}
            <div>
              <h3 className="font-bold text-slate-800 mb-3 text-base">{c.modifications}</h3>
              <p>{c.modificationsText}</p>
            </div>

            {/* Contacto */}
            <div className="bg-teal-50 p-4 rounded-lg border border-teal-200">
              <h3 className="font-bold text-teal-800 mb-2 text-base">{c.contact}</h3>
              <p className="flex items-center gap-2">📧 soporte@cmpublicaciones.com</p>
              <p className="flex items-center gap-2">📱 +54 351 732-7514</p>
            </div>
          </div>
        </ScrollArea>

        {/* Checkbox y botones */}
        <div className="border-t pt-4 mt-4">
          <div className="flex items-center space-x-3 mb-4">
            <Checkbox 
              id="accept-terms" 
              checked={accepted}
              onCheckedChange={setAccepted}
            />
            <label 
              htmlFor="accept-terms" 
              className="text-sm font-medium cursor-pointer text-slate-700"
            >
              {c.acceptLabel}
            </label>
          </div>
          
          <div className="flex gap-3 justify-end">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              {c.cancelBtn}
            </Button>
            <Button 
              onClick={handleAccept}
              disabled={!accepted}
              className="bg-teal-600 hover:bg-teal-700"
            >
              {c.acceptBtn}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TerminosCondicionesModal;
